// Fix 52 (2026-10-07): mapa de EE. UU. en cuadros del mismo tamaño (50
// estados + D. C.), ubicados aproximadamente donde quedan en el país. Con
// cuadros iguales todos se pueden tocar en el celular (Rhode Island, Delaware y
// D. C. son casi imposibles de tocar en un mapa con las formas reales).
// Cuanto más oscuro el dorado, más ventas tiene el estado.
import React from 'react';

// [código, columna, fila] en una grilla de 12 × 8.
export const TILES = [
  ['AK', 0, 0], ['ME', 11, 0],
  ['VT', 10, 1], ['NH', 11, 1],
  ['WA', 1, 2], ['ID', 2, 2], ['MT', 3, 2], ['ND', 4, 2], ['MN', 5, 2], ['IL', 6, 2],
  ['WI', 7, 2], ['MI', 8, 2], ['NY', 9, 2], ['RI', 10, 2], ['MA', 11, 2],
  ['OR', 1, 3], ['NV', 2, 3], ['WY', 3, 3], ['SD', 4, 3], ['IA', 5, 3], ['IN', 6, 3],
  ['OH', 7, 3], ['PA', 8, 3], ['NJ', 9, 3], ['CT', 10, 3],
  ['CA', 1, 4], ['UT', 2, 4], ['CO', 3, 4], ['NE', 4, 4], ['MO', 5, 4], ['KY', 6, 4],
  ['WV', 7, 4], ['VA', 8, 4], ['MD', 9, 4], ['DE', 10, 4],
  ['AZ', 2, 5], ['NM', 3, 5], ['KS', 4, 5], ['AR', 5, 5], ['TN', 6, 5], ['NC', 7, 5],
  ['SC', 8, 5], ['DC', 9, 5],
  ['OK', 4, 6], ['LA', 5, 6], ['MS', 6, 6], ['AL', 7, 6], ['GA', 8, 6],
  ['HI', 0, 7], ['TX', 4, 7], ['FL', 9, 7],
];

const GOLD = '212, 168, 67'; // #D4A843, el dorado de los gráficos

export default function UsTileMap({ data, selected, onSelect, describe, lessLabel, moreLabel }) {
  const max = Math.max(0, ...Object.values(data || {}).map((d) => d.total || 0));
  return (
    <div className="space-y-3">
      <div className="w-full overflow-x-auto">
        <div
          className="grid gap-1 min-w-[460px]"
          style={{ gridTemplateColumns: 'repeat(12, minmax(0, 1fr))' }}
          data-testid="us-tile-map"
        >
          {TILES.map(([code, col, row]) => {
            const d = (data || {})[code] || { total: 0 };
            const ratio = max > 0 ? (d.total || 0) / max : 0;
            const hasSales = (d.total || 0) > 0;
            const isSelected = selected === code;
            return (
              <button
                key={code}
                type="button"
                onClick={() => onSelect(code)}
                title={describe ? describe(code, d) : code}
                className={`aspect-square rounded-md border flex items-center justify-center text-[11px] font-semibold leading-none transition-transform hover:scale-105 ${
                  isSelected ? 'ring-2 ring-foreground ring-offset-1 ring-offset-background' : ''
                } ${hasSales ? 'border-transparent' : 'border-border text-muted-foreground'}`}
                style={{
                  gridColumnStart: col + 1,
                  gridRowStart: row + 1,
                  background: hasSales ? `rgba(${GOLD}, ${0.15 + 0.85 * ratio})` : 'transparent',
                  color: hasSales && ratio > 0.45 ? '#1F1A10' : undefined,
                }}
                data-testid={`tile-${code}`}
              >
                {code}
              </button>
            );
          })}
        </div>
      </div>
      <div className="flex items-center gap-2 text-[11px] text-muted-foreground">
        <span>{lessLabel}</span>
        <div
          className="h-2 w-32 rounded-full"
          style={{ background: `linear-gradient(90deg, rgba(${GOLD},0.15), rgba(${GOLD},1))` }}
        />
        <span>{moreLabel}</span>
      </div>
    </div>
  );
}
